import { useEffect, useState } from "react";

export default function AdBanner() {
  // Disable AdSense on localhost
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Never load AdSense on localhost
    if (isLocalhost) {
      return;
    }

    setIsReady(true);
  }, [isLocalhost]);

  // During react-snap or localhost development
  if (isLocalhost || !isReady) {
    return null;
  }
  return <AdSense />;
}

function AdSense() {
  useEffect(() => {
    // Avoid loading the script more than once
    const existingScript = document.querySelector(
      'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");

      script.async = true;
      script.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5376967427348170";

      script.crossOrigin = "anonymous";

      script.onload = () => {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (error) {
          console.error("AdSense error:", error);
        }
      };

      document.head.appendChild(script);
    } else {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error("AdSense error:", error);
      }
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{
        display: "block",
        minHeight: "100px"
      }}
      data-ad-client="ca-pub-5376967427348170"
      data-ad-slot="6652868365"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}